import { fundingRateIsCurrent, fundingSettlementValue } from './fx.js';
import { QUICK_AMOUNTS_BY_CURRENCY, USD_ANCHORS } from './quick-amount-tiers.js';
/** Share the trade form's local tiers; provider bounds and fresh FX remain authoritative. */
export function fundingPresets(currency, decimals, fx, now, bounds) {
    if (!fx || !fundingRateIsCurrent(fx, now))
        return [];
    try {
        const major = 10n ** BigInt(decimals);
        // Validate the pair even for curated currencies; presets must not imply FX readiness.
        fundingSettlementValue('1000000', currency, decimals, fx);
        const curated = QUICK_AMOUNTS_BY_CURRENCY[currency];
        const values = curated
            ? curated.map((amount) => BigInt(amount) * major)
            : USD_ANCHORS.map((amount) => snapWholeTier(BigInt(fundingSettlementValue((BigInt(amount) * 1000000n).toString(), currency, decimals, fx)), major));
        return [
            ...new Set(values
                .filter((amount) => amount > 0n &&
                (bounds?.minimumUnits === undefined || amount >= BigInt(bounds.minimumUnits)) &&
                (bounds?.maximumUnits === undefined || amount <= BigInt(bounds.maximumUnits)))
                .map(String)),
        ].slice(0, 4);
    }
    catch {
        // Missing valuation pairs have no safe localized presets; typing remains available.
        return [];
    }
}
function snapWholeTier(units, major) {
    let step = major;
    while (step * 10n <= units)
        step *= 10n;
    const tier = units * 2n < step * 3n ? 1n : units * 2n < step * 7n ? 2n : units * 2n < step * 15n ? 5n : 10n;
    return tier * step;
}
